module.exports = __webpack_public_path__ + "static/media/dark-theme-idling-alt.fa4eac6e.svg";